define('commons/device-location-filter-form',['jquery', 'commons/filter-form', 'async!google-maps'], function($, FilterForm) {
    /**
     * Form to filter and display the device locations on the map
     */
    var DeviceLocationFilterForm = function(container, options) {
        FilterForm.call(this, container, $.extend(options, {
            dataType: "json"
        }));

        //Initialize the map
        this.markers = [];
        this.polylines = [];

        var $form = $(this.form);
        this.$mapCanvas = $form.find("#map-canvas");
        this.$mapCanvasParent = this.$mapCanvas.parent();
        this.$noLocation = $form.find("#no-location");
        this.$paginatorParent = $form.find(".paginator").parent();
        this.$linkPrev = this.$paginatorParent.find(".paginator-link-previous");
        this.$linkNext = this.$paginatorParent.find(".paginator-link-next");
        this.$pageNumber = this.$paginatorParent.find(".page-number");

        $("#center-map-button").click($.proxy(this.fitBounds, this));
        $("#center-to-last-position-button").click($.proxy(this.centerToLast, this));

        this.map = null;
        this.info = new google.maps.InfoWindow({
            maxWidth: 200
        });
    };

    //Inherit from FilterForm
    for ( var element in FilterForm.prototype) {
        DeviceLocationFilterForm.prototype[element] = FilterForm.prototype[element];
    }

    DeviceLocationFilterForm.prototype.handleResult = function(data) {
        this.loadData(data);
        this._updatePagination(data.page);
    };
    /**
     * Clear the markers on the map
     */
    DeviceLocationFilterForm.prototype._clearMarkers = function() {
        if (this.markers) {
            for (i in this.markers) {
                this.markers[i].setMap(null);
            }
            this.markers = [];
        }
        if (this.polylines) {
            for (i in this.polylines) {
                this.polylines[i].setMap(null);
            }
            this.polylines = [];
        }
    };
    
    var cap = function(v) {
    	if (typeof v == 'number') {
    		return Math.round(v * 1000000) / 1000000;
    	}
    	
    	return v;
    };

    /**
     * Create the points and the polylines to display on the map
     */
    DeviceLocationFilterForm.prototype._displayMap = function(mapData) {
        var here = this;

        this.firstPoint = new google.maps.LatLng(mapData.points[0].lat, mapData.points[0].lng);
        this.bounds = new google.maps.LatLngBounds(this.firstPoint, this.firstPoint);

        if (this.map == null) {
            this.map = new google.maps.Map(this.$mapCanvas.get(0), {
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                scaleControl: true,
                rotateControl : false
            });
            this.map.setTilt(0);
        }

        this._clearMarkers();
        function markerClick(event) {
            var content = '<div>';
            content += '<strong>Date</strong>: ' + this.data.date + '<br/>';
            content += '<strong>Best RSSI</strong>: ' + this.data.rssi + '<br/>';
            content += '<strong>Latitude</strong>: ' + cap(this.data.lat) + '<br/>';
            content += '<strong>Longitude</strong>: ' + cap(this.data.lng) + '<br/>';
            
            for (var varName in (this.data.extra || {})) {
                content += '<strong>' + varName + '</strong>: ' + cap(this.data.extra[varName]) + '<br/>';
            }
            
            content += '</div>';
            here.info.setContent(content);
            here.info.open(here.map, this);
        };

        var pathPos = [];
        $(mapData.points).each(function() {
            var pos = new google.maps.LatLng(this.lat, this.lng);
            here.bounds.extend(pos);
            var marker = new google.maps.Marker({
                map: here.map,
                position: pos,
                title: this.date,
                optimized: false
            });
            marker.data = this;
            here.markers.push(marker);
            google.maps.event.addListener(marker, 'click', markerClick);
            pathPos.push(pos);
        });

        var pathLine = new google.maps.Polyline({
            path: pathPos,
            strokeColor: "#FF0000",
            strokeOpacity: 1.0,
            strokeWeight: 2
        });
        pathLine.setMap(this.map);
        this.polylines.push(pathLine);
        this.fitBounds(this.bounds);
    };

    DeviceLocationFilterForm.prototype._updatePagination = function(page) {
        this.$pageNumber.html("page " + page.page);
        if (page.hasPrevious) {
            this.$linkPrev.data("params", page.previousPageParams);
            this.$linkPrev.show();
        } else {
            this.$linkPrev.hide();
        }
        if (page.hasNext) {
            this.$linkNext.data("params", page.nextPageParams);
            this.$linkNext.show();
        } else {
            this.$linkNext.hide();
        }
    };

    /**
     * Create the points and the polylines to display on the map
     */
    DeviceLocationFilterForm.prototype.loadData = function(data) {
        // Refesh the google map
        if (data.points.length == 0) {
            this.$mapCanvasParent.hide();
            this.$paginatorParent.hide();
            this.$noLocation.show();
        } else {
            this.$noLocation.hide();
            this.$mapCanvasParent.show();
            this.$paginatorParent.show();
            this._displayMap(data);
        }
    };

    /**
     * Center the map around the points
     */
    DeviceLocationFilterForm.prototype.fitBounds = function() {
        if (this.markers.length > 1) {
            this.map.fitBounds(this.bounds);
        } else {
            this.map.setCenter(this.markers[0].getPosition());
            this.map.setZoom(17);
        }
    };

    /**
     * Center the map around the last point
     */
    DeviceLocationFilterForm.prototype.centerToLast = function() {
        this.map.setCenter(this.firstPoint);
        this.map.setZoom(17);
    };

    return DeviceLocationFilterForm;
});
